export default __webpack_public_path__ + "static/media/red-felt.262babd2.webp";